import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useZgApi = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  return environment.zgApi;
};
